'use client'

import React from 'react'
import { createContext, useContext } from 'use-context-selector'
import { usePathname } from 'next/navigation'
import useSWR from 'swr'
import { useAppContext } from './app-context'
import { fetchConfig } from '@/service/config'

export type ConfigContextValue = {
  STORAGE_TYPE: string
  maas: {
    enabled: boolean
  }
  billing: {
    enabled: boolean
  }
  appbuilder: {
    enabled: boolean
  }
  mlops: {
    train: {
      enabled: boolean
    }
    deploy: {
      enabled: boolean
    }
    ecs: {
      enabled: boolean
    }
  }
}

const defaultConfigValue: ConfigContextValue = {
  STORAGE_TYPE: '',
  maas: {
    enabled: false,
  },
  billing: {
    enabled: false,
  },
  appbuilder: {
    enabled: false,
  },
  mlops: {
    train: {
      enabled: false,
    },
    deploy: {
      enabled: false,
    },
    ecs: {
      enabled: false,
    },
  },
}

const ConfigContext = createContext<ConfigContextValue>(defaultConfigValue)

type IConfigProviderProps = {
  children: React.ReactNode
}

const superOnlyRoutePrefixes = [
  // '/ecs/clusters',
  '/ecs/storage_clusters',
  // '/ecs/audit_logs',
  // '/ecs/resource_quotas',
]

const billingRequiredRoutes = ['/bill']

export const ConfigProvider = ({ children }: IConfigProviderProps) => {
  const { data: config } = useSWR('/api/config', fetchConfig)
  const { isSuper } = useAppContext()
  const pathname = usePathname()
  const configValue = (config as ConfigContextValue) || defaultConfigValue

  // ========== 临时调试: 强制设置 billing.enabled 为 true ==========
  // TODO: 调试完成后删除此代码块
  // if (configValue) {
  //   configValue = {
  //     ...configValue,
  //     billing: {
  //       enabled: false, // 强制启用 billing，用于调试
  //     },
  //   }
  // }
  // ========== 调试代码结束 ==========

  // 检查超级管理员路由
  // useEffect(() => {
  //   if (
  //     !isSuper &&
  //     superOnlyRoutePrefixes.some(prefix => pathname.startsWith(prefix))
  //   ) {
  //     globalThis.location.href = '/'
  //   }
  // }, [isSuper, pathname])

  // // 检查 billing 相关路由
  // useEffect(() => {
  //   // config 还未加载完成时不执行检查，避免错误跳转
  //   if (!config)
  //     return

  //   console.log('configValue:', JSON.stringify(configValue, null, 2))

  //   if (
  //     (!configValue.billing?.enabled &&
  //       billingRequiredRoutes.some(route => pathname.startsWith(route))) ||
  //     (!configValue.mlops?.ecs?.enabled && pathname.startsWith('/ecs')) ||
  //     (!configValue.mlops?.train?.enabled && pathname.startsWith('/train')) ||
  //     (!configValue.mlops?.deploy?.enabled && pathname.startsWith('/deploy'))
  //   ) {
  //     globalThis.location.href = '/'
  //   }
  // }, [config, configValue.billing?.enabled, configValue.mlops?.ecs?.enabled, configValue.mlops?.train?.enabled, configValue.mlops?.deploy?.enabled, pathname])

  return (
    <ConfigContext.Provider value={configValue}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfigContext = () => useContext(ConfigContext)
